import type { ButtonHTMLAttributes } from 'react'

export type ButtonVariant = 'primary' | 'ghost' | 'danger'
export type ButtonSize = 'md' | 'sm'

interface ButtonClassOptions {
  variant?: ButtonVariant
  size?: ButtonSize
  full?: boolean
  className?: string
}

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary: 'bg-gold text-ink',
  ghost: 'bg-text-2/10 text-text border border-text-2/20',
  danger: 'bg-transparent text-red border border-red'
}

/** Delte Tailwind-klasser til knap-udseendet, så både <button> og <Link> kan bruge det. */
export function buttonClasses({ variant = 'primary', size = 'md', full = false, className = '' }: ButtonClassOptions = {}): string {
  const base =
    'inline-flex items-center justify-center gap-2 rounded-xl font-bold no-underline transition-transform active:scale-[0.98] disabled:opacity-45 disabled:cursor-not-allowed focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold focus-visible:outline-offset-2'
  const sizeClasses =
    size === 'sm' ? 'min-h-9 rounded-[10px] px-3 text-[0.9em]' : 'min-h-[calc(46px*var(--scale))] px-[18px]'
  const widthClass = full ? 'w-full' : ''
  return [base, sizeClasses, VARIANT_CLASSES[variant], widthClass, className].filter(Boolean).join(' ')
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  full?: boolean
}

function Button({ variant = 'primary', size = 'md', full = false, className = '', ...rest }: ButtonProps) {
  return <button className={buttonClasses({ variant, size, full, className })} {...rest} />
}

export default Button
